import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { StorageHandlerService } from './storage-handler.service';

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  private sharingData = {};
  public themeChange = new Subject();
  public shareHandleStatus = new BehaviorSubject('');
  public theme: string;
  public selectedBanks: any[] = [];
  /*** Sets the item in the object
     * @prop : Key of the object
     * @value : Value to be store in the object.
     */
  public setData(prop: string, value: any) {
    // internally mutate our state
    this.sharingData[prop] = value;
  }

  /*** Gets the item from the object.
 * @prop : Key of the object to fetch value.
 */
  public getData(prop?: any) {
    // use our state getter for the clone
    const data = this.sharingData;
    return data.hasOwnProperty(prop) ? data[prop] : ''; // data;
  }
  public selectedBankDetails(){
    this.selectedBanks = JSON.parse(StorageHandlerService.get('fipDetails'));
    return this.selectedBanks.map(bank => bank.fipName);
  }
}
